import PropTypes from 'prop-types'

const SimpleList = ({ children }) => (
  <div>
    {children}
  </div>
)

SimpleList.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimpleList